const { getErrorName } = require('./get-error-name')
const { notAuthError } = require('./not-auth-error')

module.exports = {
  getErrorName,
  notAuthError
}
